export const CONVERSATION_FILTER_ID = 'conversation-filter';
